const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry instanceof Function) {
    import("web-vitals").then(({ getCLS, getFCP, getLCP, getTTFB, getINP }) => {
      getCLS(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
      getINP(onPerfEntry); // replaces getFID (removed in web-vitals v3)
    });
  }
};

export default reportWebVitals;
